export enum PartnerPaymentStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  DECLINED = 'DECLINED',
  DELAYED = 'DELAYED',
  WAITING_FOR_INVOICE = 'WAITING_FOR_INVOICE',
  NO_EARNINGS = 'NO_EARNINGS'
}

enum PaymentType {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

// TODO: check if used
export type Payment = {
  id: string;
  invoiceId: string;
  amount: string;
  bonus: string | null;
  status: PartnerPaymentStatus;
  type: PaymentType;
  adId: string | null;
  description: string | null;
  paymentMonth: Date | null;
  paidAt: Date | null;
  createdAt: Date;
};
